<template>
  <ba-search-card>
    <template>
      <form @submit.prevent="handleFilterResults">
        <div class="cols">
          <div v-if="tab === DASHBOARD_TABS.NOTIFICATION" class="col">
            <ba-select v-model="provider_id" :label="$t('page.dashboard.supplier')" :allow-empty="true"
              :empty-label="$t('page.dashboard.all')">
              <option v-for="(company, index) in companies" :key="`company${index}`" :value="company.id">
                {{ company.label }}
              </option>
            </ba-select>
          </div>

          <div v-if="tab === DASHBOARD_TABS.ALERT" class="col">
            <ba-select v-model="user_id" :label="$t('page.dashboard.sellerInternal')" :allow-empty="true"
              :empty-label="$t('page.dashboard.all')">
              <option v-for="(user, index) in users" :key="`user${index}`" :value="user.id">
                {{ user.first_name }} {{ user.last_name }}
              </option>
            </ba-select>
          </div>


          <div v-if="tab === DASHBOARD_TABS.NOTIFICATION" class="col">
            <ba-select v-model="notificationType" :label="$t('page.dashboard.notificationType')" :allow-empty="true"
              :empty-label="$t('page.dashboard.all')">
              <option v-for="(value, index) in notificationTypes" :key="`notification${index}`" :value="value.id">
                {{ value.label }}
              </option>
            </ba-select>
          </div>

          <div v-if="tab === DASHBOARD_TABS.NOTIFICATION" class="col">
            <div class="basic-date date-width">
              <label>{{ $t("page.dashboard.dateStart") }}</label>
              <datepicker id="start" v-model="dateStart" name="start" class="basic-datepicker position-left"
                format="dd/MM/yyyy" :highlighted="highlighted" :monday-first="true" :language="fr" />
              <ab-icon icon="calendar" iconset="calendarSet" />
            </div>
          </div>

          <div v-if="tab === DASHBOARD_TABS.NOTIFICATION" class="col">
            <div class="basic-date date-width">
              <label>{{ $t("page.dashboard.dateEnd") }}</label>
              <datepicker id="end" v-model="dateEnd" name="end" class="basic-datepicker position-left"
                format="dd/MM/yyyy" :highlighted="highlighted" :monday-first="true" :language="fr" />
              <ab-icon icon="calendar" iconset="calendarSet" />
            </div>
          </div>

          <div v-if="tab === DASHBOARD_TABS.ALERT" class="col">
            <ba-select v-model="notificationAlertType" :label="$t('page.dashboard.notificationAlertType')"
              :allow-empty="true" :empty-label="$t('page.dashboard.all')">
              <option v-for="(value, index) in notificationAlertTypes" :key="`alert${index}`" :value="value.id">
                {{ value.label }}
              </option>
            </ba-select>
          </div>

          <div v-if="tab === DASHBOARD_TABS.ALERT" class="col">
            <div class="basic-date date-width">
              <label>{{ $t("page.dashboard.dateStart") }}</label>
              <datepicker id="start" v-model="dateStartAlert" name="start" class="basic-datepicker position-left"
                format="dd/MM/yyyy" :highlighted="highlighted" :monday-first="true" :language="fr" />
              <ab-icon icon="calendar" iconset="calendarSet" />
            </div>
          </div>

          <div v-if="tab === DASHBOARD_TABS.ALERT" class="col">
            <div class="basic-date date-width">
              <label>{{ $t("page.dashboard.dateEnd") }}</label>
              <datepicker id="end" v-model="dateEndAlert" name="end" class="basic-datepicker position-left"
                format="dd/MM/yyyy" :highlighted="highlighted" :monday-first="true" :language="fr" />
              <ab-icon icon="calendar" iconset="calendarSet" />
            </div>
          </div>

          <div v-if="tab === DASHBOARD_TABS.ALERT" class="col">
            <ba-checkbox v-model="deletedAlertsBool">
              {{ $t("page.dashboard.deletedAlerts") }}
            </ba-checkbox>
          </div>
        </div>

        <div class="search-buttons-ctn flex flex-end">
          <div class="buttons-container flex flex-end">
            <div class="tooltip-container">
              <span @click="handleResetFilter" class="filter-link">
                <ab-icon class="refresh" icon="refresh" />
              </span>
              <div class="tooltip">
                {{ $t("action.resetFilter") }}
              </div>
            </div>
            <ba-button class="primary">
              {{ $t("action.search") }}
            </ba-button>
          </div>
        </div>
      </form>
    </template>
  </ba-search-card>
</template>

<script>
import {
  AbIcon,
  BaButton,
  BaSelect,
  BaSearchCard,
  BaCheckbox
} from "@ab/basic-components";
import { mapState } from "vuex";
import { fr } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";
import { DASHBOARD_TABS } from "@/constants/dashboard";
import searchMixin from '@/components/mixins/search.js';
import { generateSearchWatcherDouble } from '@/assets/js/helpers.js';


const today = new Date();
const FILTERS = {
  provider_id: '',
  notificationType: null,
  notificationAlertType: null,
  dateStart: null,
  dateEnd: null,
  dateStartAlert: null,
  dateEndAlert: null,
  deletedAlerts: false,
  user_id: ''
};
const FILTER_KEYS = Object.keys(FILTERS);

export default {
  name: "DashboardFilters",
  components: {
    AbIcon,
    BaButton,
    BaSelect,
    BaSearchCard,
    BaCheckbox,
    Datepicker
  },
  mixins: [ searchMixin ],
  props: {
    tab: {
      require: true,
      type: String,
      default: DASHBOARD_TABS.NOTIFICATION
    }
  },

  data() {
    return {
      fr,
      highlighted: { dates: [ today ] },
      DASHBOARD_TABS,
      ...FILTERS,
      ...this.generateSearchData(FILTER_KEYS),
    };
  },
  computed: {
    ...mapState({ companies: state => state.companies.sellers }),
    ...mapState({ sellers: state => state.companies.internal.sellers }),
    ...mapState({ users: state => state.users.sellers }),
    ...mapState({
      notificationTypes: state => state.notifications.notificationTypes
    }),
    ...mapState({
      notificationAlertTypes: state =>
        state.notifications.notificationAlertTypes
    }),
    deletedAlertsBool: {
      get() {
        return this.deletedAlerts === true || this.deletedAlerts === "true";
      },
      set(val) {
        this.deletedAlerts = Boolean(val);
      }
    },
  },
  watch: {
    ...generateSearchWatcherDouble(FILTER_KEYS),
  },
  async mounted() {
    // await this.$store.dispatch("getCompanyUsers");
    await this.$store.dispatch("getCompanySellers");
  },
  async created() {
    this.handleFilterResults();
  },
  methods: {
    handleResetFilter() {
      if (this.tab === DASHBOARD_TABS.NOTIFICATION) {
        this.provider_id = '';
        this.notificationType = '';
        this.dateStart = null;
        this.dateEnd = null;
      } else if (this.tab === DASHBOARD_TABS.ALERT) {
        this.user_id = '';
        this.notificationAlertType = '';
        this.dateStartAlert = null;
        this.dateEndAlert = null;
        this.deletedAlerts = false;
      }
      this.handleFilterResults();
    },
    async handleFilterResults() {
      if (this.tab === DASHBOARD_TABS.NOTIFICATION) {
        this.searchData.provider_id = this.provider_id;
        this.searchData.notificationType = this.notificationType;
        this.searchData.dateStart = this.dateStart;
        this.searchData.dateEnd = this.dateEnd;
      } else if (this.tab === DASHBOARD_TABS.ALERT) {
        this.searchData.notificationAlertType = this.notificationAlertType;
        this.searchData.dateStartAlert = this.dateStartAlert;
        this.searchData.dateEndAlert = this.dateEndAlert;
        this.searchData.deletedAlerts = this.deletedAlerts;
        this.searchData.user_id = this.user_id;
      }

      this.$emit("handle-filter",
        {
          provider_id: this.provider_id,
          notificationType: this.notificationType,
          notificationAlertType: this.notificationAlertType,
          dateStart: this.dateStart,
          dateEnd: this.dateEnd,
          dateStartAlert: this.dateStartAlert,
          dateEndAlert: this.dateEndAlert,
          deletedAlerts: this.deletedAlerts,
          user_id: this.user_id
        },
        this.tab);
    }
  }
};
</script>

<style scoped>
.ba-search-card {
  width: 100%;
  margin-bottom: 2rem;
}
.basic-date.date-width {
  width: 100%;
}

.cols {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.col {
  flex: 1 1 calc(25% - 1rem);
  max-width: 240px;
  min-width: 200px;
  padding: 0 1rem;
  padding-bottom: 1.5rem;
}
</style>
